import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { matchPath } from 'react-router'
import clsx from 'clsx'
import { IconButton, Button, Typography } from '@material-ui/core'
import { openDialog } from 'app/auth/store/actions/createNotification.actions'
import { onClickNavigation } from 'app/store/actions/fuse/navigation.actions.js'
import { useDispatch, useSelector } from 'react-redux'
import { usePlace } from 'commons/usePlace'
import * as R from 'ramda'
import { useIntl } from 'react-intl'
import { FuseUtils } from '@fuse'
import { useIsPlacePendingActivateHasAccess } from 'app/auth/authHooks'
import AccessControl from 'app/auth/AccessControl'
import { AccessType } from 'app/auth/accessControlService'
import AvatarWithFallback from 'app/components/AvatarWithFallback'
import Assets from 'app/configs/assetConfigs'
import { Routes } from 'app/services/routeService/routeService'
import { isNil } from 'ramda'
import { SCOPE_BEACON } from 'app/constants/scope'
import { ACTION_NEW, GENERAL_DIALOG } from 'app/constants/compose'
import { useFlag } from '@unleash/proxy-client-react'
import Chat from './Chat'

const useStyles = makeStyles((theme) => ({
  composeBtn: {
    width: '100%',
    '& .MuiButton-root': {
      textTransform: 'capitalize !important',
    },
    '&:hover': {
      backgroundColor: 'unset !important',
    },
  },
  textBtn: {
    backgroundColor: theme.colors.secondary,
  },
  memuButton: {
    display: 'flex',
    margin: 'auto',
    padding: '5px 8px',
    '& .MuiIconButton-label': {
      display: 'unset',
      textTransform: 'capitalize',
    },
    '&:hover': {
      backgroundColor: 'unset !important',
    },
  },
  iconBtn: {
    width: '50px',
    height: '38px',
    margin: 'auto',
    padding: '5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundColor: theme.colors['menu-active'],
    width: '40px',
    '&:hover': {
      backgroundColor: theme.colors['menu-active'],
    },
    justifyContent: 'center',
  },
  noActive: {
    '&:hover': {
      backgroundColor: theme.colors['primary-500'],
    },
  },
}))

export default (props) => {
  const { history, item, disabled } = props
  const classes = useStyles()
  const dispatch = useDispatch()
  const mes_3908_place_profile = useFlag('mes_3908_place_profile')
  const mes_5122 = useFlag('mes_5122_navigation_support_manager_web')

  const place = usePlace()
  const { formatMessage } = useIntl()
  const isPendingActiveMenu = useIsPlacePendingActivateHasAccess()
  const userRole = useSelector(({ auth }) => auth.user.role)
  const { onCreateSuccess } = useSelector(({ auth }) => auth.createNotification)

  const onSuccseAndRedirectPage = (res, scope) => {
    const pathname =
      scope === SCOPE_BEACON
        ? Routes.beaconNotification()
        : Routes.notificationTimeline()

    const match = matchPath(history.location.pathname, {
      path: pathname,
    })

    if (isNil(match)) {
      history.push(pathname)
    } else {
      onCreateSuccess()
    }
  }

  const onOpenCreateNotificationDialog = () => {
    dispatch(
      openDialog({
        initialValues: undefined,
        onCreateSuccess: onSuccseAndRedirectPage,
        type: GENERAL_DIALOG,
        action: ACTION_NEW,
      }),
    )
  }

  const onClickMainMenu = (item) => {
    dispatch(onClickNavigation(item.id))
    const defaultUrl = R.find((item) => {
      return item.isDefault
    })(item.children)
    let url = defaultUrl && defaultUrl.url
    if (
      R.isNil(defaultUrl) ||
      (defaultUrl.id === 'manage-channels' && place.enabledAutomatedCall === 0)
    ) {
      const newItem = item.children.filter((item) => {
        return item.id !== 'manage-channels'
      })
      url = newItem[0].url
    }
    history.push(url)
  }

  const getMessageTite = (localizedId) => {
    return formatMessage({
      id: localizedId,
    })
  }

  if (!FuseUtils.hasPermission(item.auth, userRole) || R.prop('hidden', item)) {
    return null
  }

  const isDisabled =
    isPendingActiveMenu && R.includes(item.id, ['profile-info'])
      ? false
      : disabled

  return (
    <React.Fragment key={item.id}>
      {item.type === 'send-message-button' && (
        <AccessControl
          accesses={[AccessType.NOTIFICATION_SEND, AccessType.ADMINISTRATION]}
        >
          <Button
            disabled={disabled}
            className={clsx(classes.composeBtn, 'rounded-8')}
            onClick={() => {
              onOpenCreateNotificationDialog()
            }}
            data-testid="send-message-button-menu"
          >
            <div className="flex flex-col">
              <div
                className={clsx(
                  'align-middle flex justify-center px-2 py-3 mx-2 rounded-8',
                  classes.textBtn,
                )}
              >
                {item.componentIcon && item.componentIcon}
              </div>
              <Typography className="text-14 text-blue-950 font-normal normal-case mt-2">
                {getMessageTite(item.localizedId)}
              </Typography>
            </div>
          </Button>
        </AccessControl>
      )}
      {mes_5122 && item.type === 'chat-manager-web' && <Chat item={item} />}

      {item.type === 'collapse' && (
        <div className="w-full group">
          <IconButton
            disableRipple
            disabled={isDisabled}
            className={classes.memuButton}
            onClick={() => onClickMainMenu(item)}
            data-testid={`${item.id}-button-menu`}
          >
            <div
              className={clsx(
                classes.iconBtn,
                'group-hover:bg-white hover:bg-white rounded-8',
                item.isSelected && 'bg-white',
              )}
            >
              {item.componentIcon && item.componentIcon}
            </div>
            <Typography className="text-12 text-blue-950 font-normal">
              {getMessageTite(item.localizedId)}
            </Typography>
          </IconButton>
        </div>
      )}
      {(mes_3908_place_profile
        ? item.type === 'profile-info'
        : item.type === 'profile') && (
        <div className="w-full group">
          <IconButton
            disableRipple
            disabled={isDisabled}
            className={clsx(classes.memuButton, 'flex justify-center')}
            onClick={() => onClickMainMenu(item)}
            data-testid={`${item.id}-button-menu`}
          >
            <div
              className={clsx(
                classes.iconBtn,
                'group-hover:bg-white hover:bg-white rounded-8 h-44',
                item.isSelected && 'bg-white',
              )}
            >
              <AvatarWithFallback
                src={R.view(R.lensPath(['info', 'logo']), place)}
                fallbackSrc={Assets.defaultPlaceImage}
                className="border border-secondary bg-white m-auto w-32 h-32"
              />
            </div>
            <Typography className="text-12 text-blue-950 font-normal">
              {getMessageTite(item.localizedId)}
            </Typography>
          </IconButton>
        </div>
      )}
    </React.Fragment>
  )
}
